export const getEventTrackGA = (obj) => {

	if ((typeof obj !== 'undefined') && typeof ga !== 'undefined') {

		// let category = obj.category;
		// let action = obj.action;
		// let label = obj.label;
		const { category = 'quikr_pwa', action, label, ...rest } = obj;
		let windowNewOpen = obj.windowNewOpen;
		let windowOpen = obj.windowOpen;

		if (category !== '' && action !== '' && label !== '') {

			if (typeof ga !== 'undefined' && ga) {
				// _gaq.push(['_trackEvent', category, action, label, 0, true]);
				ga('quikrPWATracker.send','event', { eventCategory: category, eventAction: action, eventLabel: label, ...rest });

				// alert('Category:'+category+',action:'+action+',label:'+label);
			}
			else {
				console.log('Google Analytics not loaded');
			}

			if (typeof gen_comscore_tag === 'function') {
				gen_comscore_tag('www.quikr.com/' + category + action);
			}
		}

		if (windowNewOpen) {
			window.open(windowNewOpen, '_blank');
		}

		if (windowOpen) {
			window.location = windowOpen;
			return false;
		}
	}

};

export const setPageView = (pageUrl) => {
	if (typeof ga !== 'undefined' && ga) {
		ga('quikrPWATracker.send', 'pageview', pageUrl);
	}
};


export const pushAnalyticsEvent = (eventName, data, isMsite = true) => {
    const MAX_TRY = 10; // try 10 times
    const source = isMsite? 'Msite': 'Desktop';

    const pushEvent = (eventName, _data, source, tryCount = MAX_TRY) => {
        try{
            if(typeof _paqv3 !== 'undefined' && _paqv3){
                _paqv3.push(["_sendEventApiData", eventName, source, JSON.stringify(_data)]);
            }
else if(tryCount){
                setTimeout(() => pushEvent(eventName, _data, source, tryCount - 1), 1000);
            }
        }
catch(err){ console.log(err); }
    };

	pushEvent(eventName, data, source, MAX_TRY);
};


// WEBPACK FOOTER //
// ../q-core/src/helpers/utils/ga.js